module.exports = __webpack_public_path__ + "img/Rectangle-8.55a673ca.jpg";